import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type PreValidateRequest = {
  company: {
    name: string;
    name_kana: string;
    postal_code: string;
    prefecture_code: string;
    address: string;
  };
  company_user: {
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    email: string;
    birthday: string;
  };
};

export type PreValidateResponse = {
  is_company_exists: boolean;
  is_company_disabled: boolean;
};

export type PreValidateErrorResponse = {
  company: {
    name: string[];
    name_kana: string[];
    postal_code: string[];
    prefecture_code: string[];
    address: string[];
  };
  company_user: {
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    email: string[];
    birthday: string[];
  };
};

export const companyPreValidateApiClient = {
  preValidate: async (
    params: PreValidateRequest,
  ): Promise<ApiResult<PreValidateResponse, PreValidateErrorResponse>> => {
    return await axiosClient.post('/company/company-users/pre-validate', params);
  },
};
